"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketSubmissionDTO = void 0;
class TicketSubmissionDTO {
    constructor(data) {
        this.id = data.id;
        this.enteredTime = data.enteredTime;
        this.userKey = data.userKey;
        this.ticketEntryMethod = data.ticketEntryMethod;
        this.deviceType = data.deviceType;
        this.earnMode = data.earnMode;
        this.retailPrice = data.retailPrice;
        this.graphicImageUrl = data.graphicImageUrl;
        this.attributes = data.attributes;
        this.prizes = data.prizes;
    }
}
exports.TicketSubmissionDTO = TicketSubmissionDTO;
//# sourceMappingURL=TicketSubmissionDTO.js.map